/*  ========================================================================
    # Components - Footer
    ========================================================================  */

// Dependencies
import React, { useContext } from 'react';
import { TermsContext } from '../App';

const Footer = () => {
  const termsModalRef = useContext(TermsContext);
  const openTerms = event => {
    event.stopPropagation();
    event.preventDefault();
    termsModalRef.current?.open();
  };

  return (
    <footer className='c-footer'>
      <a href='#' onClick={openTerms} title='Teilnahmebedingungen'>
        Teilnahmebedingungen
      </a>
      <a
        href='#'
        onClick={event => {
          event.preventDefault();
          window.BorlabsCookie?.openCookiePreference();
        }}
        title='Cookie-Einstellungen'
      >
        Cookies
      </a>
      <a
        href='https://www.raiffeisen-gesellschaft.de/content/Raiffeisen_Gesellschaft-MS/de/homepage/footer/impressum.html'
        target='_blank'
        rel='noreferrer noopener'
        title='Impressum'
      >
        Impressum
      </a>
      <a
        href='https://www.raiffeisen-gesellschaft.de/content/Raiffeisen_Gesellschaft-MS/de/homepage/footer/datenschutz.html'
        target='_blank'
        rel='noreferrer noopener'
        title='Datenschutzerklärung'
      >
        Datenschutzerklärung
      </a>
    </footer>
  );
};

export default Footer;
